import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../utils/checkout';
interface CTAButtonProps {
  label: string;
  subline?: string;
  className?: string;
  id?: string;
}
export function CTAButton({
  label,
  subline,
  className = '',
  id
}: CTAButtonProps) {
  return <div className={`w-full ${className}`} id={id} data-id="element-26" data-mp="2fz22aptk92x3">
      <a href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-2 rounded-2xl bg-gold-500 px-5 py-4 text-center text-base font-extrabold uppercase leading-tight tracking-wide text-navy-950 shadow-gold transition-[transform,background-color] duration-200 ease-out hover:bg-gold-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-500 active:scale-[0.98] sm:text-lg" data-id="element-27" data-mp="2fya6bdw1x36a">
        <span data-id="element-28" data-mp="3cqvsnppordfj">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-29" data-mp="3cq3ymjbqlnrd" />
      </a>
      {subline && <p className="mt-3 text-center text-[13px] font-medium text-slate-500" data-id="element-30" data-mp="19azi2eh64djc">{subline}</p>}
    </div>;
}